<div class="cx-modal-container">
  <div class="duplicate-eca-content">
    <div class="cx-dialog-body duplicate-eca-body">
      <header>
        <div class="duplicate-eca-header">
          <span class="cx-dialog-title">
            {{ 'duplicateEca.productAlreadyExistsTitle' | cxTranslate }}
          </span>
          <span (click)="onClose('Cross click')" class="close-icon">
            <bh-icon icon="close" size="medium" color="primary" href="" target=""></bh-icon>
          </span>
        </div>
      </header>
      <div class="cx-dialog-content">
        <p class="cx-dialog-text">
            {{ 'duplicateEca.productAlreadyExistsLine1' | cxTranslate }}
        </p>
        <p class="cx-dialog-text">
          {{ 'duplicateEca.productAlreadyExistsLine2' | cxTranslate }}
        </p>
      </div>
      <div class="cx-dialog-actions d-flex justify-content-between duplicate-eca-footer">
        <div class="col-6 p-0">
          <bh-button type=secondary label="{{ 'duplicateEca.changeEndCustomerAddress' | cxTranslate }}" fluid (click)="changeEca()"></bh-button>
        </div>
        <div class="col-6 pl-0">
          <bh-button type=primary label="{{ 'duplicateEca.increaseQuantity' | cxTranslate }}" fluid (click)="increaseQty()"></bh-button>
        </div>
      </div>
    </div>
  </div>
